module.exports = __webpack_public_path__ + "static/media/arrow-off-sudeste.c5b10438.png";